import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

export const MUTATION = graphql(`
  mutation UpdateHappyHour(
    $id: ID!
    $input: UpdateOnlineOrderHappyHourInput!
    $timeRuleInput: UpdateMenuSectionTimeRule!
  ) {
    updateHappyHour(id: $id, input: $input, timeRuleInput: $timeRuleInput) {
      id
      deliveryType
      discountType
      discountAmount
      minimumOrderAmount
      isActive

      timeRule {
        __typename
        ... on MenuSectionAlwaysTimeRule {
          type
        }

        __typename
        ... on MenuSectionRangeTimeRule {
          type
          start
          end
          daysOfWeek
          isAllDays
        }
      }
    }
  }
`);

export default function useUpdateHappyHour() {
  return useMutation(MUTATION, {
    refetchQueries: ['GetHappyHours', 'GetHappyHour'],
  });
}
